// extracted by mini-css-extract-plugin
module.exports = {"tiles":"tiles_tiles__19ruc","tile":"tiles_tile__lRgdE","inactive":"tiles_inactive__bZpse","top-right":"tiles_top-right__3qWZt"};